export enum TenureType {
    Default = 1,
    Land = 2,
    Custom = 3
}